const ResetIcon = () => (
  <svg
    className='reset_icon'
    width='18px'
    height='18px'
    viewBox='0 0 18 18'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Reset to default</title>
    <g
      id='Artboard'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <path
        d='M8.5,1.5 C12.3607772,1.5 15.5402093,4.41718524 15.9543277,8.16758711 L17.8151855,8.16748047 L15,11.699707 L11.8864746,8.16748047 L13.9373202,8.16694937 C13.5358556,5.52469153 11.2543738,3.5 8.5,3.5 C6.99639882,3.5 5.59145644,4.10491103 4.56222257,5.1602156 C3.56636857,6.18129478 3,7.54470821 3,9 C3,12.0375661 5.46243388,14.5 8.5,14.5 C9.87196883,14.5 11.1621995,13.9965858 12.1607271,13.1049036 L12.3564811,12.9214244 L13.7589252,14.3473103 C12.3659207,15.7174135 10.4934827,16.5 8.5,16.5 C4.35786438,16.5 1,13.1421356 1,9 C1,7.01762757 1.773851,5.15474374 3.13043383,3.76379839 C4.53231111,2.32641128 6.4517012,1.5 8.5,1.5 Z'
        id='Combined-Shape'
        fill='#000000'
        fillRule='nonzero'
      />
    </g>
  </svg>
)

export default ResetIcon
